import React from 'react';
import {HashRouter, Route} from "react-router-dom";
import {IntlProvider} from "react-intl";

import './assets/css/main.css';
import localeData from "./i18n/data.json";
import {PATH} from "./routes/routes.js";
import {refreshOnTabChange} from "./util/common";
import {Routes} from "react-router";
import ReactDOM from "react-dom/client";
import ProfileHome from "./views/Authentication/ProfileHome";
import TableQrScan from "./views/TableQrScan";
import Menu from "./views/EatIn/Menu";
import Login from "./views/Authentication/Login";
import Register from "./views/Authentication/Register";
import ProfileUpdate from "./views/Authentication/ProfileUpdate";
import ProfileChangePassword from "./views/Authentication/ProfileChangePassword";
import ProfileDelete from "./views/Authentication/ProfileDelete";
import Main from "./views/Main";
import Schedules from "./views/Schedules";
import AllReservations from "./views/Reservation/AllReservations";
import CreateReservation from "./views/Reservation/CreateReservation";
import ReservationDetails from "./views/Reservation/ReservationDetails";
import LoginOrContinueAsGuest from "./views/Authentication/LoginOrContinueAsGuest";
import ScanQrToContinue from "./components/ScanQrToContinue";
import TakeAwayMenu from "./views/Takeaway/TakeAwayMenu";
import TakeAwayOrderReview from "./views/Takeaway/TakeAwayOrderReview";
import TakeAwayThankYou from "./views/Takeaway/TakeAwayThankYou";
import BarPickupThankYou from "./views/EatIn/BarPickupThankYou";
import LinkScan from "./views/LinkScan";
import BarPickupScan from "./views/BarPickupScan";
import ProductDetails from "./views/ProductDetails";
import OrderReview from "./views/EatIn/OrderReview";
import TableOrderSummary from "./views/EatIn/TableOrderSummary";
import TablePayment from "./views/EatIn/TablePayment";
import TableThankYou from "./views/EatIn/TableThankYou";
import OrderHistory from "./views/OrderHistory";
import PhoneUpdate from "./views/Authentication/PhoneUpdate";
import PhoneUpdateEnterPin from "./views/Authentication/PhoneUpdateEnterPin";
import GroupOrderReview from "./views/EatIn/GroupOrderReview";
import GroupOrderSummary from "./views/EatIn/GroupOrderSummary";
import GroupPayment from "./views/EatIn/GroupPayment";
import ExternalRedirect from "./views/ExternalRedirect";

// addLocaleData([...en, ...ro]);
require('@formatjs/intl-pluralrules/polyfill');
require('@formatjs/intl-pluralrules/locale-data/en');
require('@formatjs/intl-pluralrules/locale-data/ro');
require('@formatjs/intl-relativetimeformat/polyfill');
require('@formatjs/intl-relativetimeformat/locale-data/de');


let language =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage;

let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

if (localeData[languageWithoutRegionCode] === undefined) {
    languageWithoutRegionCode = localeData.defaultLang;
}

const messages = localeData[languageWithoutRegionCode];

const App = () => {
    refreshOnTabChange();

    return(
            <HashRouter>
                <main className="wrapper">
                    <div className="content">
                        <Routes>
                            <Route exact path={PATH.ROOT} element={<ExternalRedirect />}/>
                            <Route exact path={PATH.LOGIN} element={<Login />}/>
                            <Route exact path={PATH.REGISTER} element={<Register />}/>
                            <Route exact path={PATH.PROFILE_HOME} element={<ProfileHome />}/>
                            <Route exact path={PATH.PROFILE_UPDATE} element={<ProfileUpdate />}/>
                            <Route exact path={PATH.PROFILE_UPDATE_PHONE} element={<PhoneUpdate />}/>
                            <Route exact path={PATH.PROFILE_UPDATE_PHONE_PIN_CONFIRMATION +"/:phone"} element={<PhoneUpdateEnterPin />}/>
                            <Route exact path={PATH.PROFILE_CHANGE_PASSWORD} element={<ProfileChangePassword />}/>
                            <Route exact path={PATH.PROFILE_DELETE} element={<ProfileDelete />}/>
                            <Route exact path={PATH.MAIN} element={<Main />}/>
                            <Route exact path={PATH.SCHEDULES} element={<Schedules />}/>
                            <Route exact path={PATH.ALL_RESERVATIONS} element={<AllReservations />}/>
                            <Route exact path={PATH.CREATE_RESERVATION} element={<CreateReservation />}/>
                            <Route exact path={PATH.RESERVATION_DETAILS+"/:rid"} element={<ReservationDetails />}/>
                            <Route exact path={PATH.ALL_PRODUCTS} element={<Menu />}/>
                            <Route exact path={PATH.LOGIN_OR_CONTINUE_AS_GUEST} element={<LoginOrContinueAsGuest />}/>
                            <Route exact path={PATH.SCAN_QR_TO_CONTINUE} element={<ScanQrToContinue />}/>
                            <Route exact path={PATH.TAKEAWAY} element={<TakeAwayMenu />}/>
                            <Route exact path={PATH.TAKEAWAY_ORDER_REVIEW} element={<TakeAwayOrderReview />}/>
                            <Route exact path={PATH.TAKEAWAY_THANK_YOU +"/:orderId"} element={<TakeAwayThankYou />}/>
                            <Route exact path={PATH.BAR_THANK_YOU +"/:orderId"} element={<BarPickupThankYou />}/>
                            <Route exact path={PATH.TABLE_QR_SCAN +"/:shopName/:userTable"} element={<TableQrScan />}/>
                            <Route exact path={PATH.LINK_SCAN +"/:shopName"} element={<LinkScan />}/>
                            <Route exact path={PATH.PAGE_SCAN +"/:shopName/:page"} element={<LinkScan />}/>
                            <Route exact path={PATH.BAR_PICKUP_SCAN +"/:shopName"} element={<BarPickupScan />}/>
                            <Route exact path={PATH.PRODUCT_DETAILS +"/:pid"} element={<ProductDetails />}/>
                            <Route exact path={PATH.ORDER_REVIEW} element={<OrderReview />}/>
                            <Route exact path={PATH.GROUP_ORDER_REVIEW +"/:goid"} element={<GroupOrderReview />}/>

                            <Route exact path={PATH.ORDER_SUMMARY} element={<TableOrderSummary />}/>
                            <Route exact path={PATH.GROUP_ORDER_SUMMARY +"/:goid"} element={<GroupOrderSummary />}/>
                            <Route exact path={PATH.GROUP_PAYMENT +"/:goid"} element={<GroupPayment />}/>
                            <Route exact path={PATH.PAYMENT} element={<TablePayment />}/>
                            <Route exact path={PATH.THANK_YOU +"/:orderId"} element={<TableThankYou />}/>
                            <Route exact path={PATH.ORDER_HISTORY +"/:orderId"} element={<OrderHistory />}/>
                        </Routes>
                    </div>
                </main>
            </HashRouter>
      );
}

ReactDOM.createRoot(document.getElementById('root')).render(

        <IntlProvider locale={languageWithoutRegionCode} messages={messages}>

            <App />
        </IntlProvider>
);

